var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7394 4.85555C17.0003 4.15134 18.4532 3.75 20 3.75C21.5468 3.75 22.9998 4.15134 24.2606 4.85555L25.183 3.93307C25.4271 3.68898 25.8229 3.68898 26.067 3.93307C26.311 4.17714 26.311 4.57287 26.067 4.81694L25.3265 5.55744C27.4083 7.15698 28.75 9.67179 28.75 12.5H11.25C11.25 9.67179 12.5918 7.15698 14.6735 5.55744L13.933 4.81694C13.689 4.57287 13.689 4.17714 13.933 3.93307C14.1771 3.68898 14.5729 3.68898 14.817 3.93307L15.7394 4.85555ZM17.5 8.75C17.5 9.44035 16.9404 10 16.25 10C15.5596 10 15 9.44035 15 8.75C15 8.05965 15.5596 7.5 16.25 7.5C16.9404 7.5 17.5 8.05965 17.5 8.75ZM23.75 10C24.4404 10 25 9.44035 25 8.75C25 8.05965 24.4404 7.5 23.75 7.5C23.0596 7.5 22.5 8.05965 22.5 8.75C22.5 9.44035 23.0596 10 23.75 10Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 15.625C6.25 14.5895 7.08946 13.75 8.125 13.75C9.16054 13.75 10 14.5895 10 15.625V23.125C10 24.1605 9.16054 25 8.125 25C7.08946 25 6.25 24.1605 6.25 23.125V15.625Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30V34.375C15 35.4105 15.8395 36.25 16.875 36.25C17.9105 36.25 18.75 35.4105 18.75 34.375V30H21.25V34.375C21.25 35.4105 22.0895 36.25 23.125 36.25C24.1605 36.25 25 35.4105 25 34.375V30H26.25C27.6308 30 28.75 28.8807 28.75 27.5V13.75H11.25V27.5C11.25 28.8807 12.3693 30 13.75 30H15Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.625C30 14.5895 30.8395 13.75 31.875 13.75C32.9105 13.75 33.75 14.5895 33.75 15.625V23.125C33.75 24.1605 32.9105 25 31.875 25C30.8395 25 30 24.1605 30 23.125V15.625Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformAndroid);
export default __webpack_public_path__ + "static/media/platform_android.3ed37321f2adb204adc17ffdd592bae7.svg";
export { ForwardRef as ReactComponent };